<main>
        <div class="contenedor">
            <!-- Header del proyecto -->
            <section class="header-proyecto">
                <div class="imagen-proyecto"></div>
                <div class="titulo-con-flecha">
                    <a routerLink="/portafolio" class="btn-regreso">
                        <img src="assets/svg/flecha.svg" alt="Regresar">
                    </a>
                    <h1 class="titulo-proyecto">Nuevo Aeropuerto Internacional Jorge Chávez – LAP</h1>
                </div>
                <div class="cuadro_ubicacion">
                    <div class="ubicacion-proyecto">
                    <span class="icono-ubicacion"><img src="assets/svg/IconoMap.svg" alt=""></span>
                        Callao
                    </div>
                </div>
                
            </section>

            <section class="seccion-info-proyecto">
                <div class="grid-info">
                    <div class="info-columna">
                        <h3>Importancia</h3>
                        <p>La obra aeroportuaria más importante del Perú en las últimas décadas. Permitirá duplicar la capacidad operativa del aeropuerto, posicionando a Lima como un aeropuerto central de conexión aérea para Sudamérica.</p>
                    </div>
                    <div class="separador-vertical"></div>
                    <div class="info-columna">
                        <h3>Descripción del proyecto</h3>
                        <p>Consiste en la construcción de una nueva torre de control, pistas de aterrizaje, terminales, redes de servicios y sistemas inteligentes.</p>
                    </div>
                </div>
            </section>

            <section class="seccion-participacion">
                <div class="contenido-participacion">
                    <div class="circulo-azul-decorativo"></div>
                    <div class="info-participacion">
                        <h2>Participación de Corporación Rehobot</h2>
                        <p>Se ejecutaron trabajos especializados para garantizar el <strong>abastecimiento del recurso hídrico subterráneo</strong> en apoyo a los procesos constructivos del proyecto, incluyendo <strong>evaluación técnica, diseño hidráulico, equipamiento e instalación de sistemas de bombeo y control.</strong></p>
                    </div>
                    <div class="imagen-participacion"></div>
                </div>
            </section>

            <section class="seccion-actividades">
                <h2 class="actividades-titulo">Actividades <span>desarrolladas.</span></h2>
                <div class="contenido-actividades">
                    <div class="tarjeta-actividad">
                    </div>
                    <div class="tarjeta-lista-actividades">
                        <ul class="lista-actividades">
                            <li><strong>Evaluación estructural y de rendimiento del pozo</strong>, mediante inspección con cámara de video sumergible y aforo, realizando los cálculos para el diseño hidráulico de la electrobomba.</li>
                            <li><strong>Suministro e instalación de una electrobomba sumergible</strong> de 100 HP (caudal de 62 l/s), columna de impulsión con accesorios hidráulicos Ø 6”.</li>
                            <li><strong>Diseño, suministro e instalación</strong> del árbol hidráulico.</li>
                            <li><strong>Diseño, suministro e instalación del tablero de control</strong>, con variador de velocidad, sistema de protección y automatización.</li>
                            <li><strong>Gestión del sistema de control de bombeo y abastecimiento de agua</strong> para procesos constructivos y mitigación de polvo, complementado con abastecimiento mediante camiones cisterna durante un periodo de 2 años.</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="seccion-mas-proyectos">
              <div class="divisor-linea"></div>
              <h2 class="mas-proyectos-titulo">Más <span>proyectos.</span></h2>

              <div class="grid-mas-proyectos">
                <div class="tarjeta-obra-mini" *ngFor="let obra of proyectosRecomendados">
                  <div class="imagen-obra-mini"
                       [style.backgroundImage]="'url(' + obra.imagen + ')'">
                  </div>
                  <div class="contenido-mini">
                    <h3>{{ obra.titulo }}</h3>
                    <a [routerLink]="obra.link" class="btn-conoce-mas">Conoce más</a>
                  </div>
                </div>
              </div>
            </section>
        </div>
    </main>